// extracted by mini-css-extract-plugin
module.exports = {"stepperCompleted":"#006938","stepperActive":"#000","stepperTextColor":"#fff"};